import { debounce } from '@/utils/aha-utils';
import PerfectScrollbar from 'perfect-scrollbar';

const state = new WeakMap();
const resizeEvent = 'resize';

export default {
    bind(el) {
        state.set(el, {
            resizeEventListener: null,
            scrollbar: null
        });
    },
    inserted (el, directive, vnode) {
        const data = state.get(el);

        const resizeEventHandler = debounce(() => {
            if(window.outerWidth >= 576 && data.scrollbar === null) {
                data.scrollbar = new PerfectScrollbar(el, {
                    suppressScrollY: true,
                    wheelPropagation: true,
                    wheelSpeed: 0.4
                });
            }

            if(window.outerWidth < 576 && data.scrollbar !== null) {
                data.scrollbar.destroy();
            }
        }, 100);

        data.resizeEventListener = resizeEventHandler;

        window.addEventListener(resizeEvent, resizeEventHandler);
        resizeEventHandler();
    },
    unbind(el) {
        const data = state.get(el);

        window.removeEventListener(resizeEvent, data.resizeEventListener);

        if(data.scrollbar !== null) {
            data.scrollbar.destroy();
            data.scrollbar = null; // to make sure garbages are collected
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/directives/perfect-scrollbar.js